export default {
  SET_ACCOUNT_DATA: 'SET_ACCOUNT_DATA',
  SET_ACCOUNT_DATA_ERROR: 'SET_ACCOUNT_DATA_ERROR',
  SET_COVERED_MEMBERS: 'SET_COVERED_MEMBERS',
  SET_COVERED_MEMBERS_ERROR: 'SET_COVERED_MEMBERS_ERROR'
};
